import Service from '../../Services/Service'

const ContactAPI = {
    sendMsgVenueHire(data) {
        return Service.post(`/customer-support/venue-hire`, {
            to: data.to ? data.to : undefined,
            branch_id: data.branch_id,
            message: data.message,
            email: data.email,
            phone: data.phone,
            token: data.token
        });
    },
    sendMsgGroupVisit(data) {
        return Service.post(`/customer-support/group-visit`, {
            branch_id: data.branch_id,
            message: data.message,
            email: data.email,
            phone: data.phone,
            organization_name: data.organization_name,
            token: data.token
        });
    },
    sendMsgContactBranch(data) {
        return Service.post(`/customer-support/contact-branch`, {
            branch_id: data.branch_id,
            message: data.message,
            email: data.email,
            phone: data.phone,
            token: data.token
        });
    },
    getCategoryEnewsletter() {
        return Service.get(`/customer-support/newsletter-category`);
    },
    subscribeEnewsletter(data) {
        return Service.post(`/customer-support/subscribes`, {
            email: data.email,
            interested_in: data.interested
        });
    }
};

export default ContactAPI;
